import axios from 'axios';
import { PDFDocument } from 'pdf-lib';

export const savePdf = (file_obj: any) => {
  return axios
    .post(`/api/v1/document/pdf`, file_obj, {
      headers: {
        withCredentials: true,
        'Content-Type': 'multipart/form-data'
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getPdfList = (
  document_type_id: number,
  construct_name: string,
  assignee_user_id: number,
  created_user_id: number,
  start_date: string,
  end_date: string
) => {
  return axios
    .get(
      `/api/v1/document/document_id/list?document_type_id=${document_type_id}&construct_name=${construct_name}&assignee_user_id=${assignee_user_id}&created_user_id=${created_user_id}&start_date=${start_date}&end_date=${end_date}`,
      {
        headers: {
          withCredentials: true
        }
      }
    )
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};

export const getPdfData = async (document_id: number) => {
  let pdfDocData = await getPdfDataToDownload(document_id);
  const pdfDoc = await PDFDocument.load(pdfDocData.data);
  const exportPdf = await pdfDoc.save();
  return await new Blob([exportPdf.buffer], { type: 'application/pdf' });
};

export const getPdfDataToDownload = (id: number) => {
  return axios
    .get(`/api/v1/document/pdf/${id}`, {
      headers: {
        withCredentials: true
      }
    })
    .then(function (response) {
      return response.data;
    })
    .catch(err => {
      if (err.response.data) {
        if (
          err.response.data.error &&
          err.response.data.error === 'Missing cookie access_token_cookie'
        ) {
          return 'Not logged in!';
        } else return err.response.data;
      } else return err.response;
    });
};
